module.exports = "{{#if $root.CurrentView() === \"Message\"}} <div class=\"pl-hd-widget-message-view pl-hd-widget-view ms-u-textAlignCenter\"> <h2 class=\"pl-hd-widget-message-view-content ms-font-xxl\"></h2> <button type=button class=ms-Button style=display:none> <i class=ms-Icon></i> <span class=ms-Button-label></span> </button> </div> {{/if}}";


//////////////////
// WEBPACK FOOTER
// ./Widget/templates/message.html
// module id = 13
// module chunks = 1